module.exports = __webpack_public_path__ + "static/media/logo.87614f1d.svg";